export interface EvaluationType {
  [key: string]: number;
}
const evaluation1: EvaluationType = {
  selfcheck_evaluation1_1: 0,
  selfcheck_evaluation1_2: 1,
  selfcheck_evaluation1_3: 2,
  selfcheck_evaluation1_4: 3,
};
const evaluation2: EvaluationType = {
  selfcheck_evaluation2_1: 0,
  selfcheck_evaluation2_2: 1,
  selfcheck_evaluation2_3: 2,
  selfcheck_evaluation2_4: 3,
  selfcheck_evaluation2_5: 4,
};
const evaluation2_reverse: EvaluationType = {
  selfcheck_evaluation2_1: 4,
  selfcheck_evaluation2_2: 3,
  selfcheck_evaluation2_3: 2,
  selfcheck_evaluation2_4: 1,
  selfcheck_evaluation2_5: 0,
};

function Question(questionTranslationKey: string, evaluation: EvaluationType) {
  return {
    questionTranslationKey: questionTranslationKey,
    evaluation: evaluation,
  };
}

export type SelfCheckIdType = "depression" | "anxiety" | "stress";

export type SelfCheckDataType = {
  [key in SelfCheckIdType]: {
    title: string;
    screeningTool: string;
    questionList: {
      questionTranslationKey: string;
      evaluation: EvaluationType;
    }[];
    result: { label: string; range: number[] }[];
    abnormalScore: number;
  };
};

export const selfCheckData: SelfCheckDataType = {
  depression: {
    title: "우울",
    screeningTool: "PHQ-9",
    questionList: [
      Question("depression_1", evaluation1),
      Question("depression_2", evaluation1),
      Question("depression_3", evaluation1),
      Question("depression_4", evaluation1),
      Question("depression_5", evaluation1),
      Question("depression_6", evaluation1),
      Question("depression_7", evaluation1),
      Question("depression_8", evaluation1),
      Question("depression_9", evaluation1),
    ],
    result: [
      { label: "정상", range: [0, 4] },
      { label: "가벼움", range: [5, 9] },
      { label: "중간", range: [10, 14] },
      { label: "심함", range: [15, 19] },
      { label: "극심함", range: [20, 27] },
    ],
    abnormalScore: 10,
  },
  anxiety: {
    title: "불안",
    screeningTool: "GAD-7",
    questionList: [
      Question("anxiety_1", evaluation1),
      Question("anxiety_2", evaluation1),
      Question("anxiety_3", evaluation1),
      Question("anxiety_4", evaluation1),
      Question("anxiety_5", evaluation1),
      Question("anxiety_6", evaluation1),
      Question("anxiety_7", evaluation1),
    ],
    result: [
      { label: "정상", range: [0, 4] },
      { label: "가벼움", range: [5, 9] },
      { label: "중간", range: [10, 14] },
      { label: "심함", range: [15, 21] },
    ],
    abnormalScore: 10,
  },
  stress: {
    title: "스트레스",
    screeningTool: "PSS",
    questionList: [
      Question("stress_1", evaluation2),
      Question("stress_2", evaluation2),
      Question("stress_3", evaluation2),
      Question("stress_4", evaluation2_reverse),
      Question("stress_5", evaluation2_reverse),
      Question("stress_6", evaluation2),
      Question("stress_7", evaluation2_reverse),
      Question("stress_8", evaluation2_reverse),
      Question("stress_9", evaluation2),
      Question("stress_10", evaluation2),
    ],
    result: [
      { label: "정상", range: [0, 12] },
      { label: "가벼움", range: [13, 15] },
      { label: "중간", range: [16, 18] },
      { label: "심함", range: [19, 40] },
    ],
    abnormalScore: 16,
  },
};
